"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reScaleY = exports.getIntegralYScale = exports.getYScale = exports.getXScale = exports.useScaleY = exports.useScaleX = void 0;
const d3_1 = require("d3");
const ChartContext_1 = require("../../context/ChartContext");
const react_1 = require("react");
const useVerticalAlign_1 = require("../../hooks/useVerticalAlign");
function getXScale(options, spectrumId = null) {
    const { width, margin, xDomains, xDomain, mode } = options;
    const range = mode === 'RTL'
        ? [width - margin.right, margin.left]
        : [margin.left, width - margin.right];
    return (0, d3_1.scaleLinear)(spectrumId ? xDomains[spectrumId] : xDomain, range);
}
exports.getXScale = getXScale;
function getYScale(options, spectrumId = null) {
    const { height, margin, verticalAlign, yDomain, yDomains } = options;
    const _height = verticalAlign === 'center'
        ? (height - 40) / 2
        : height - margin.bottom - 40;
    let domainY = [];
    if (spectrumId === null || yDomains[spectrumId] === undefined) {
        domainY = [0, yDomain[1]];
    }
    else {
        domainY = [0, yDomains[spectrumId][1]];
    }
    return (0, d3_1.scaleLinear)(domainY, [_height, margin.top]);
}
exports.getYScale = getYScale;
function getIntegralYScale(options) {
    const { height, margin, verticalAlign, integralsYDomains, activeSpectrum } = options;
    const _height = verticalAlign === 'center' ? height / 2 : height;
    return (0, d3_1.scaleLinear)(activeSpectrum?.id && integralsYDomains?.[activeSpectrum?.id]
        ? integralsYDomains[activeSpectrum?.id]
        : [0, 0], [_height * 0.3, margin.top + _height * 0.1]);
}
exports.getIntegralYScale = getIntegralYScale;
function reScaleY(scale, { domain, height, margin }) {
    const _scale = (0, d3_1.scaleLinear)(domain, [height - margin.bottom, margin.top]);
    const t = d3_1.zoomIdentity
        .translate(0, _scale(0))
        .scale(scale)
        .translate(0, -_scale(0));
    return t.rescaleY(_scale).domain();
}
exports.reScaleY = reScaleY;
function useScaleX() {
    const { margin, mode, width, xDomain, xDomains } = (0, ChartContext_1.useChartData)();
    return (0, react_1.useCallback)((spectrumId = null) => getXScale({ margin, mode, width, xDomain, xDomains }, spectrumId), [margin, mode, width, xDomain, xDomains]);
}
exports.useScaleX = useScaleX;
function useScaleY() {
    const { margin, height, yDomain, yDomains } = (0, ChartContext_1.useChartData)();
    const verticalAlign = (0, useVerticalAlign_1.useVerticalAlign)();
    return (0, react_1.useCallback)((spectrumId = null) => getYScale({ margin, height, verticalAlign, yDomain, yDomains }, spectrumId), [margin, height, verticalAlign, yDomain, yDomains]);
}
exports.useScaleY = useScaleY;
